<div class="container-fluid main">
  <!-- <app-landing-header></app-landing-header> -->
  <div class="row landing-body justify-content-center">
    
    <div class="col-12 col-md-4 col-lg-3 app-landing-form-">
      <div class="mx-auto form-wrapper bg-white rounded-2x p-4 shadow">
      

        <div class="text-small mb-1" style="font-size:0.88em; opacity: 0.6;">
          <svg style="height:16px; vertical-align: center; display: inline-block;"  width="24" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 9V7C17 5.67392 16.4732 4.40215 15.5355 3.46447C14.5979 2.52678 13.3261 2 12 2C10.6739 2 9.40215 2.52678 8.46447 3.46447C7.52678 4.40215 7 5.67392 7 7V9C6.20435 9 5.44129 9.31607 4.87868 9.87868C4.31607 10.4413 4 11.2044 4 12V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V12C20 11.2044 19.6839 10.4413 19.1213 9.87868C18.5587 9.31607 17.7956 9 17 9ZM9 7C9 6.20435 9.31607 5.44129 9.87868 4.87868C10.4413 4.31607 11.2044 4 12 4C12.7956 4 13.5587 4.31607 14.1213 4.87868C14.6839 5.44129 15 6.20435 15 7V9H9V7ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V12C6 11.7348 6.10536 11.4804 6.29289 11.2929C6.48043 11.1054 6.73478 11 7 11H17C17.2652 11 17.5196 11.1054 17.7071 11.2929C17.8946 11.4804 18 11.7348 18 12V19Z" fill="#979797"/>
            </svg>
           Restricted access
          </div>
        <h4 class="fw-bold mb-3"><b>Login to your account</b></h4>
        <form
        class=""
          [formGroup]="loginForm"
          (ngSubmit)="handleSubmit(loginForm.value)"
        >
          <div class="form-group">
            <input
              formControlName="email"
              (keyup)="clearMessage()"
              type="email"
              class="form-control"
              id="email"
              aria-describedby="emailHelp"
              placeholder="Email "
              required
            />
            <div
              *ngIf="submitted && loginForm.controls.email.errors"
              class="error_message"
            >
              <span *ngIf="loginForm.controls.email.errors.required">
                email is required
              </span>
              <span *ngIf="loginForm.controls.email.errors.email">
                must be a valid email
              </span>
            </div>
          </div>
          <div class="form-group">
            <input
              formControlName="password"
              type="password"
              class="form-control"
              id="password"
              placeholder="Password"
              (keyup)="clearMessage()"
              required
            />
            <div
              *ngIf="submitted && loginForm.controls.password.errors"
              class="error_message"
            >
              <span *ngIf="loginForm.controls.password.errors.required">
                password is required
              </span>
            </div>
          </div>
          <div *ngIf="error" class=" my-2 error_message" role="alert">
            {{ error }}
          </div>
          <button class="btn btn-block btn-primary btn-lg" [disabled]="isLoggedIn||loading">
            <div>
              <span
                *ngIf="loading"
                class="spinner-border spinner-border-sm text-white"
                role="status"
              ></span>
              <span *ngIf="loading" class="pl-3">Logging in...</span>
            </div>
            <span *ngIf="!loading">
              Login
            </span>
          </button>
        </form>
        <p class="mt-4 mb-0">
          <a routerLink="/forgot-password">Forgot Password?</a>
        
        </p>
        <!-- <p class="signup-link">
          Don't have an account?
          <a routerLink="/register">Request for an account</a>
        </p> -->
       
      </div>
      <p class="mt-3 "><small>&copy; {{ dateService.year }} A Copyright Of Akorion Company Ltd</small></p>
    </div>
   
  </div>
</div>
